import firebase from "firebase";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

const firebaseDevConfig = {
  apiKey: "AIzaSyByQ0uZ6o2AAhmF9zogzdhcLn7rKRUOyJc",
  authDomain: "nxatel-dev.firebaseapp.com",
  databaseURL: "https://nxatel-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "nxatel-dev",
  storageBucket: "nxatel-dev.appspot.com",
  messagingSenderId: "697631177184",
  appId: "1:697631177184:web:546c20268e3dc0bbb8d385",
};

const firebaseLiveConfig = {
  apiKey: "AIzaSyDs6b_L8d2J66Iyj4eODmthmY1xnQedsKM",
  authDomain: "nxatel-map.firebaseapp.com",
  databaseURL: "https://nxatel-map-default-rtdb.firebaseio.com",
  projectId: "nxatel-map",
  storageBucket: "nxatel-map.appspot.com",
  messagingSenderId: "753511039530",
  appId: "1:753511039530:web:44f9cd85e24b2ac91af953",
  measurementId: "G-V2E7B5X6Q8",
};

const isDevHost = location.host.includes("dev");

firebase.initializeApp(isDevHost ? firebaseDevConfig : firebaseLiveConfig);
export const firebaseApp = firebase;
export const firebaseAuth = firebase.auth();
export const firebaseDatabase = firebase.database();
export const isFCMSupported = firebaseApp.messaging.isSupported();
export const myStorage = firebase.storage();

export default firebase;
